import { render } from "./Dashboard.vue?vue&type=template&id=1264347a&scoped=true&bindings={}"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=1264347a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1264347a"

export default script